// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"314":"setting","331":"boss","535":"login","676":"languages"}[chunkId] + "." + {"314":"92ed68fa","331":"8f078247","535":"99e3c231","676":"36a94a4b"}[chunkId] + ".js";
};